import {createApp} from "vue";
import {createRouter, createWebHistory} from "vue-router";

import mitt from 'mitt';
import "bootstrap";
import App from "./App.vue";
import Login from "./components/Login.vue";
import Logout from "./components/Logout.vue";
import Settings from "./components/Settings";
import Translations from "./components/Translations";
import DeleteUserAccount from "./components/DeleteUserAccount";
import LoginOIDC from "@/components/LoginOIDC.vue";

const emitter = mitt();

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {path: "/", component: Translations},
        {path: "/logout", component: Logout},
        {path: "/login", component: Login},
        {path: "/login/oidc", component: LoginOIDC},
        {path: "/settings", component: Settings},
        {path: "/delete-user-account", component: DeleteUserAccount},
    ]
});

export default router;

const app = createApp(App);

app.config.globalProperties.emitter = emitter;

app.use(router);
app.mount("#app");
